<template>
  <v-container class="home-page height-100 d-flex">
    <v-row justify="start" class="mx-4" align="center">
      <v-col cols="12" sm="12" md="12" lg="12" xl="11">
        <v-alert text type=" text-center"
          ><div class="text-center grey--text">Please use the side menu to navigate to the corresping page</div>
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {};
</script>

<style>
</style>